<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap> 
          <v-flex md6 class="col-12 fxt-bg-img" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form fxt-footer">                                              
                  <span v-show="isShowLink" class="mb-3">
                      {{$t("updateEmail.updateMsg")}}
                      <v-btn flat medium color="primary" @click="updateEmail">{{$t("updateEmail.sureMsg")}}</v-btn>
                    </span>
                    <span v-show="isShowMessage" class="mt-5">
                      <div class="mb-3">{{$t("updateEmail.noValidMsg")}}</div>
                      <div>
                        <v-btn flat medium color="primary" @click="goHome">{{$t("allPage.homepage")}}</v-btn>
                      </div>
                    </span>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<style>
</style>
<script>
import config from "../../config.js";
import $ from 'jquery';
export default {
  data() {
    return {
      isShowLink: false,
      domainName: config.ip,
      isShowMessage: false
    };
  },
  mounted: function() {
    //浏览器窗口发生变化时同时变化DIV高度
    window.onresize = this.autodivheight();
    this.verifyLink();
    this.background();
  },
  methods: {
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    //自动获得div高度
    autodivheight() {
      //函数：获取尺寸
      //获取浏览器窗口高度
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      } //通过深入Document内部对body进行检测，获取浏览器窗口高度
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }
      //DIV高度为浏览器窗口的高度:winHeight - 66
      //document.getElementById("content").style.height = winHeight + "px";
    },
    //验证链接是否有效
    verifyLink() {
      let currentUrl = window.location.href;
      let email = currentUrl.substring(
        currentUrl.indexOf("=", 1) + 1,
        currentUrl.indexOf("#", 1)
      );
      this.$http
        .get(config.baseUrl + "emailLink/open/verifyLink?regEmail=" + email)
        .then(
          function(successData) {
            let data = successData.data;
            if (data.resCode == 0) {
              this.isShowLink = true;
              this.isShowMessage = false;
            } else if (data.resCode == -1) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: this.$t("common.warning"),
                desc: this.$t("updateEmail.noRegisterNotice")
              });
            } else if (data.resCode == -2) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: this.$t("common.warning"),
                desc: this.$t("updateEmail.activatedNotice")
              });
            } else if (data.resCode == -3) {
              this.isShowLink = false;
              this.isShowMessage = true;
              this.$Notice.warning({
                title: this.$t("common.warning"),
                desc: this.$t("updateEmail.timeOutNotice")
              });
            }
          },
          function(errorData) {
            this.$Message.error(this.$t("common.fail"));
          }
        );
    },
    //跳转成功页面
    gotoresgistersuccess: function() {
      this.$router.push({ name: "resgistersuccess" });
    },
    //跳转到主页
    goHome() {
      window.location.href = config.ip;
    },
    //
    updateEmail() {
      let url = window.location.href;
      let email = url.substring(url.indexOf("=", 1) + 1, url.indexOf("#", 1));
      let url1 = config.baseUrl + "user/updateEmail?regEmail=" + email;
      let that = this;
      this.$http.get(url1, this.formInline).then(
        function(successData) {
          let data = successData.data;
          if (data.resCode == 0) {
            this.$Notice.success({
              title: this.$t("common.success"),
              desc: this.$t("updateEmail.successNotice")
            });
            this.goHome();
          } else if (data.resCode == -1) {
            this.$Message.error(this.$t("common.serverError"));
          }
        },
        function(errorData) {
          this.$Message.error(this.$t("common.fail"));
        }
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// UpdateEmail.vue?7e93a359